import { render, staticRenderFns } from "./icon-arrow-primary.vue?vue&type=template&id=ee05bea8&scoped=true"
import script from "./icon-arrow-primary.vue?vue&type=script&lang=js"
export * from "./icon-arrow-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee05bea8",
  null
  
)

export default component.exports